export default __webpack_public_path__ + "static/media/NP_logo_short_2_edge.ac31204c.png";